import React, { Component } from 'react'
import { ListItem } from 'material-ui/List'


class StudentStagedForInviteItem extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.student !== this.props.student
  }

  render() {
    const { student } = this.props
    const displayText = `Student Email: ${student.email}`
    return (
      <ListItem primaryText={displayText} />
    )
  }
}

export default StudentStagedForInviteItem



// WEBPACK FOOTER //
// ./src/views/components/student-staged-for-invite-item/index.js